import React from 'react'
import { Form, Formik } from 'formik'
import { ContainerDiv, FjFormItem, FormActionButtons, FormHeaderText } from 'src/components/Common'
import { UserSelect } from 'src/components/Feed/UserSelect'
import { isRequired } from 'src/utils/validation'
import { AssignmentSubmission } from 'src/models/AssignmentSubmission'
import { sharedAppStateStore } from 'src/store/AppStateStore'

export interface IAssignGraderFormModalProps {
  assignmentSubmission: AssignmentSubmission
  onSuccess: () => void
  onCancel: () => void
}

export const AssignGraderForm = ({ assignmentSubmission, onCancel, onSuccess }: IAssignGraderFormModalProps) => {
  const handleSubmit = async ({ graderId }) => {
    try {
      await sharedAppStateStore.wrapAppLoading(assignmentSubmission.save({ graderId }, true, true))
    } catch (err) {
      sharedAppStateStore.handleError(err)
    }
    onSuccess()
  }

  return (
    <ContainerDiv>
      <FormHeaderText heading="Select Grader" />
      <Formik
        onSubmit={handleSubmit}
        initialValues={{ graderId: assignmentSubmission.grader?.id }}
        isInitialValid
        enableReinitialize
        validateOnMount
      >
        <Form>
          <FjFormItem fieldtitle="Grader*" name="graderId" validate={isRequired}>
            <UserSelect
              name="graderId"
              placeholder="Grader"
              excludeUserIds={[assignmentSubmission.userId]}
              initialLabel={assignmentSubmission.grader?.fullName}
              queryParams={{ access_role: 'standard,admin,manager,partner' }}
            />
          </FjFormItem>
          <FormActionButtons onCancel={onCancel} />
        </Form>
      </Formik>
    </ContainerDiv>
  )
}
